<template>
  <g>
    <path
      d="M5.03565 6.50001L0.208241 1.6726C-0.054244 1.41011 0.13166 0.961305 0.50287 0.961305L10.1577 0.961304C10.5289 0.961304 10.7148 1.41011 10.4523 1.6726L5.62491 6.50001C5.46219 6.66273 5.19837 6.66273 5.03565 6.50001Z"
      fill="#1C1C1E"
    />
    <path
      d="M5.03565 6.50001L0.208241 1.6726C-0.054244 1.41011 0.13166 0.961305 0.50287 0.961305L10.1577 0.961304C10.5289 0.961304 10.7148 1.41011 10.4523 1.6726L5.62491 6.50001C5.46219 6.66273 5.19837 6.66273 5.03565 6.50001Z"
      fill="black"
      fill-opacity="0.2"
    />
  </g>
</template>
